<template>
  <div class="space-y-8">
    <Tags :account-id="accountId" />
    <ClientAnatomy :account-id="accountId" />
  </div>
</template>

<script>
import ClientAnatomy from '@/components/AccountSettings/ClientAnatomy.vue';
import Tags from '@/components/AccountSettings/Tags.vue';

export default {
  components: {
    ClientAnatomy,
    Tags,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
};
</script>
